import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ContentItem } from '@frontend/vanilla/core';
import { ContentMessagesService, ContentMessagesComponent as PureContentMessagesComponent } from '@frontend/vanilla/features/content-messages';
import { DslPipe } from '@frontend/vanilla/shared/browser';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [CommonModule, DslPipe, PureContentMessagesComponent],
    selector: 'vn-am-content-messages',
    templateUrl: 'content-messages.html',
})
export class ContentMessagesComponent extends AccountMenuItemBase implements OnInit {
    private contentMessagesService = inject(ContentMessagesService);

    messages: ContentItem[] = [];
    closedCookieKey: string | undefined;
    private readonly destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        if (this.item.parameters['source']) {
            this.closedCookieKey = this.item.parameters['closed-cookie-key'];
            this.contentMessagesService
                .getMessages('contentMessages')
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(
                    (
                        messages:
                            | ContentItem[]
                            | {
                                  [key: string]: ContentItem[];
                              },
                    ) => {
                        const key = this.item.parameters['source']?.toLowerCase();
                        if (key != null && !(messages instanceof Array)) {
                            this.messages = messages[key] || [];
                        }
                    },
                );
        }
    }
}
